import gql from 'graphql-tag';

import { FEED_QUESTION_DETAILS_FRAGMENT } from '../fragments/feed/feedQuestionDetails';

export const GET_QUESTIONS_SUBSCRIPTION = gql`
  subscription GetQuestionsSubscription(
    $boardId: String!
    $filterPublishStatus: FilterPublishStatus!
    $labelIds: [String!]!
  ) {
    question(boardId: $boardId, filterPublishStatus: $filterPublishStatus, labelIds: $labelIds) {
      ...feedQuestionDetails
      plex {
        id
        summary {
          id
          faqsCount
        }
      }
    }
  }
  ${FEED_QUESTION_DETAILS_FRAGMENT}
`;
